import Table from '/src/components/table/Table.js';
import { useState, useEffect } from 'react';
import ApiModal from '/src/components/modal/ApiModal/ApiModal';
import './ConversationTableUpGoing.css';
import ConversationDetailsModal from '../../ConversationDetailsModal/ConversationDetailsModal';
import NiceModal from '@ebay/nice-modal-react';
import { formatDateWithoutSeconds } from '/src/utils/dateWithoutSeconds';
import IconsConversation from '../../../data/types/IconsConversation';
import ConversationFilterModal from '../../ConversationFilter/ConversationFilterModal';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import ConversationUpGoingService from '../../../services/ConversationUpGoingService';
import { getStorageParamForCurrentCompany } from '/src/utils/storageParamForCurrentCompany';
import storage from '/src/utils/storage';
import "../Completed/ConversationTableCompleted.css"
import InputBox from "/src/components/UI/InputBox/InputBox";
function ConversationTableUpGoing({ setRefreshList, resetList = false }) {

    const { getConversations, deleteConversation, deleteMultiplesConversation } = ConversationUpGoingService;
    const [filterValues, setFilterValues] = useState(getStorageParamForCurrentCompany('conversation_filters'));
    const [refreshTable, setRefreshTable] = useState(false)

    const [rows, setRows] = useState([]);

    const user = storage('local').get('user');

    //const choicesChannel = Object.keys(Icons).map(key => { return { value: key, text: <img width="20px" srcSet={Icons[key]}></img> } })
    const cells = [
        {
            name: 'bot_job_id',
            column: 'Check',
            show: (value) => <InputBox id={"bot_job_id" + value} name="bot_job_id" setValue={(name, checked) => {console.log(value); handleCheck(value,checked);}} check={rows.includes(value)}></InputBox>
        },
        {
            name: 'bot_job_type.name',
            column: 'Channel',
            show: (value) => <img width="20px" srcSet={IconsConversation[value]}></img>
        },
        {
            name: 'bot_job_id',
            column: 'ID',
            show: (value) => value,
            sort: true
        },
        {
            name: 'schedule',
            column: 'Date',
            show: (value) => formatDateWithoutSeconds(value, true),
            sort: true
        },
        {
            name: 'bot.name',
            column: 'Bot',
            show: (value) => <p>{value}</p>,
            sort: true
        },
        {
            name: 'url',
            column: 'URL',
            show: (value) => <p>{value}</p>
        },

    ];
    const handleCheck = (id, checked) => {
        setRows((prev) => prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id] ) };
        console.log(rows)

    const onClickRefresh = () => {
        setRefreshTable(!refreshTable)
    }

    const handleFilterSubmit = (filters) => {
        setFilterValues(filters);
    }

    const onClickSearch = () => {
        NiceModal.show(ConversationFilterModal, {
            title: 'Search conversation',
            postbackAction: handleFilterSubmit,
            mode: 2,
        })
    }
    const onClickView = ({ row }) => {
        NiceModal.show(ConversationDetailsModal, {
            data: row,
            title: 'Conversation details',
            state: 3
        })
    }
    const onClickDeleteRows = () => {
        let ids  = rows.map(row => row);
        console.log(ids);
        let deleteObject = {
            title: 'Delete conversations',
            body: 'Do you really want to delete all the conversations selected ?',
            api: {
                request: deleteMultiplesConversation,
                param : [ { ids : ids}  ]
            },
            buttons: [
                { className: 'validate', label: 'Cancel' },
                { className: 'cancel', label: 'Delete', type: 'submit' },
            ]
          
        }
        NiceModal.show(ApiModal, deleteObject).then(() => setRefreshTable(!refreshTable))
    };
    const onClickDelete = ({ row, deleteRow }) => {
        const { id, bot_job_id, bot } = row;
        let deleteObject = {
            title: 'Delete conversation',
            body: 'Do you really want to delete conversation from the bot ' + bot.name + '?',
            api: {
                request: deleteConversation,
                param: [bot_job_id, { bot_id: bot.id }]
            },
            buttons: [
                { className: 'validate', label: 'Cancel' },
                { className: 'cancel', label: 'Delete', type: 'submit' },
            ]
        }
        /*
          confirm: {
                name:  bot.name,
                fieldName: "the bot",
            }
            */
        if (!user.is_admin) {
            deleteObject = {
                ...deleteObject,
                confirm: {
                    name: bot.name,
                    fieldName: "the bot",
                }
            }
        }
        NiceModal.show(ApiModal, deleteObject).then(() => deleteRow(bot_job_id, 'bot_job_id'))
    };

    const actions = [
        { className: "fas fa-file-alt action-button profil_action", style: {}, onClick: onClickView, title: "Details" },        
        // {className : "fas fa-thumbtack action-button profil_action", style : {}, onClick : onClickView,title: "mark conversation" },
        { className: "fas fa-trash action-button delete_action", style: {}, onClick: onClickDelete, title: "Delete conversation" },
    ];
    const buttons = [
        { icon: "fas fa-sync", onClick: onClickRefresh },
        { className: "main-iconButton profil_action main_add-button" + (!Object.keys(filterValues).length == 0 ? " conversations_active_filter" : ""), icon: "fas fa-filter", onClick: onClickSearch },
        { className: "main-iconButton delete_action main_add-button", icon: "fas fa-trash", onClick: onClickDeleteRows },
    ].filter(button => button);


    useEffect(() => {
        setRefreshList();
    }, [filterValues])

    useEffect(() => {
        onClickRefresh();
    }, [resetList])

    return (
        <Table name="conversation" buttons={buttons} filterValues={filterValues} refreshState={[refreshTable, setRefreshTable]} className='table-conversation' cells={cells} api={getConversations} actions={actions} supplementaryParamUrl={filterValues} setRefreshTable={setRefreshTable} refreshTable={refreshTable}  ></Table>
    );
}

export default ConversationTableUpGoing;